<template>
    <v-btn
        :size="size"
        :density="density"
        :color="color"
        :variant="variant"
        :to="{ name: 'AccountDetails', params: { accountId } }"
        :target="target"
        title="View Account Details"
        :append-icon="showOpenInIcon && target !== undefined ? 'mdi-open-in-new' : undefined"
    >
        Account #{{ accountId }}
    </v-btn>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
    accountId: {
        type: Number,
        required: true
    },
    size: {
        type: String as PropType<'x-small' | 'small' | 'large' | 'x-large'>,
        default: 'large'
    },
    density: {
        type: String as PropType<'compact' | 'comfortable'>
    },
    variant: {
        type: String as PropType<'elevated' | 'flat' | 'tonal' | 'outlined' | 'text' | 'plain'>,
        default: 'tonal'
    },
    color: {
        type: String,
        default: 'primary'
    },
    target: {
        type: String
    },
    showOpenInIcon: {
        type: Boolean,
        default: false
    }
})
</script>
